import React, { useContext } from "react";
import { useTheme } from "@emotion/react";
import { createStackNavigator } from "@react-navigation/stack";
import { cardStyleInterpolatorSlide } from "myplan/utils/navigation";
import DrawerButton from "../../components/DrawerButton";
import RichText from "myplan/components/RichText";
import PrivacyPolicy from "myplan/screens/PrivacyPolicy";
import { FurnitureContext } from "myplan/utils/furniture";
import {
    StackContainer,
    Container,
    Background,
    Scroll,
    Header,
    PrivacyPolicyCtaContainer,
    PrivacyPolicyCta,
} from "./styles";

const Stack = createStackNavigator();

const AboutNavigator = () => {
    const { backgroundPattern }: any = useTheme();
    return (
        <StackContainer>
            <Background source={backgroundPattern} />
            <Stack.Navigator
                headerMode="none"
                initialRouteName="About"
                screenOptions={{
                    cardStyle: { backgroundColor: "transparent" },
                    // @ts-ignore
                    cardStyleInterpolator: cardStyleInterpolatorSlide,
                }}>
                <Stack.Screen name="About" component={About} />
                <Stack.Screen
                    name="PrivacyPolicy"
                    component={PrivacyPolicy}
                    options={{ gestureDirection: "vertical" }}
                />
            </Stack.Navigator>
        </StackContainer>
    );
};

const About = ({ navigation }) => {
    const furniture = useContext(FurnitureContext);

    return (
        <Container>
            <DrawerButton />
            <Scroll>
                <Header type="h3">{furniture.aboutTitle}</Header>
                <RichText doc={furniture.aboutBody} />
                <PrivacyPolicyCtaContainer
                    onPress={() => navigation.navigate("PrivacyPolicy")}>
                    <PrivacyPolicyCta type="cta1">
                        {furniture.privacyPolicyTitle}
                    </PrivacyPolicyCta>
                </PrivacyPolicyCtaContainer>
            </Scroll>
        </Container>
    );
};

export default AboutNavigator;
